module.exports = __webpack_public_path__ + "static/media/preloader.08c257b3.svg";